export default __webpack_public_path__ + "static/media/food_Color.1db35d23.svg";